import * as React from 'react';

import { Dialog } from '@coursera/cds-core';

import AssetAdminManager from 'bundles/asset-admin/components/AssetAdminManager';
import type { PropsFromCaller } from 'bundles/asset-admin/components/AssetAdminManager';
import { DialogWithFocusOverrideProvider } from 'bundles/asset-admin/components/CdsDialogWithFocusOverride';
import { MODAL_WIDTH } from 'bundles/asset-admin/constants/TableConstants';

export type Props = PropsFromCaller & {
  autoFocusOnCloseButton?: boolean;
};

const AssetAdminModalV2 = ({ autoFocusOnCloseButton, ...props }: Props) => {
  const { Content, HeadingGroup } = Dialog;
  const { title, ...restProps } = props;
  const propsToPass = {
    ...restProps,
    assetBrowserWidth: MODAL_WIDTH,
  };
  return (
    <DialogWithFocusOverrideProvider open onClose={propsToPass.onCancel} width="large">
      {title && <HeadingGroup>{title}</HeadingGroup>}
      <Content className="rc-AssetAdminModalV2">
        <AssetAdminManager {...propsToPass} />
      </Content>
    </DialogWithFocusOverrideProvider>
  );
};

export default AssetAdminModalV2;
